var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from "vue-property-decorator";
import axios from "axios";
let OutsourceOutput = class OutsourceOutput extends Vue {
    controll = "";
    color = "#F44336";
    job = {
        id: 0,
        order_nr: "",
        amount: 0,
        total_price: 0,
        orders: {},
        get_goods: "",
        delivery_date: ""
    };
    controlldisabled = false;
    snackbar = false;
    edit = false;
    Extern = [];
    text = "";
    dia = false;
    timeout = 0;
    index = 0;
    original = 0;
    headers = [
        { text: 'Externe Auftragnummer', align: 'start', value: 'order_nr' },
        { text: 'Offenemenge', value: 'amount' },
        { text: 'Liefermenge', value: 'inamount' },
        { text: 'interner Auftrag', value: 'orders' },
        { text: 'Notiz', value: 'note' },
        { text: 'Lieferdatum:', value: 'delivery_date' },
        { text: 'Aktionen', value: 'actions' },
    ];
    getExtern() {
        this.controlldisabled = true;
        axios.get('/api/extern/notcomplete/' + this.controll).then((response) => {
            this.job = response.data.data;
            this.original = this.job.amount;
            this.createTemp();
        }).catch((error) => {
            this.text = "keine externen Auftrag mit der eingescannten nummer offen";
            this.color = "red";
            this.snackbar = true;
        });
        this.controlldisabled = false;
    }
    diaopen() {
        if (this.controll != '') {
            this.dia = true;
        }
    }
    createTemp() {
        if (this.edit) {
            // @ts-ignore
            this.Extern[this.index].id = this.job.id;
            // @ts-ignore
            this.Extern[this.index].order_nr = this.job.order_nr;
            // @ts-ignore
            this.Extern[this.index].amount = this.original - this.job.inamount;
            // @ts-ignore
            this.Extern[this.index].inamount = this.job.inamount;
            // @ts-ignore
            this.Extern[this.index].get_goods = this.job.get_goods;
            // @ts-ignore
            this.Extern[this.index].total_price = this.job.total_price;
            // @ts-ignore
            this.Extern[this.index].orders = this.job.orders;
            // @ts-ignore
            this.Extern[this.index].delivery_date = this.job.delivery_date;
        }
        else {
            this.Extern.push({
                order_nr: this.job.order_nr,
                id: this.job.id,
                amount: this.job.amount,
                inamount: 0,
                get_goods: this.job.get_goods,
                total_price: this.job.total_price,
                orders: this.job.orders,
                delivery_date: this.job.delivery_date,
            });
        }
        this.diaclose();
    }
    editDiaData(item) {
        this.edit = true;
        this.index = this.Extern.indexOf(item);
        // @ts-ignore
        this.job.id = this.Extern[this.index].id;
        // @ts-ignore
        this.job.order_nr = this.Extern[this.index].order_nr;
        // @ts-ignore
        this.job.amount = this.Extern[this.index].amount;
        // @ts-ignore
        this.job.inamount = this.Extern[this.index].inamount;
        // @ts-ignore
        this.job.get_goods = this.Extern[this.index].get_goods;
        // @ts-ignore
        this.job.total_price = this.Extern[this.index].total_price;
        // @ts-ignore
        this.job.delivery_date = this.Extern[this.index].delivery_date;
        // @ts-ignore
        this.job.orders = this.Extern[this.index].orders;
        this.diaopen();
    }
    deleteDiaData(item) {
        if (confirm("Möchten sie den Auftrag wirklich aus der Liste entfernen?")) {
            this.index = this.Extern.indexOf(item);
            this.Extern.splice(this.index, 1);
        }
    }
    diaclose() {
        this.dia = false;
        this.clear();
    }
    clear() {
        this.job = {
            id: 0,
            order_nr: "",
            amount: 0,
            inamount: 0,
            total_price: 0,
            orders: {},
            get_goods: "",
            delivery_date: ""
        };
        this.edit = false;
    }
    sendExtern() {
        if (this.controll == "") {
            this.controll = "1";
        }
        axios.put('/api/extern/complete', { extern: this.Extern }).then((response) => {
            this.text = "Die externen Aufträge wurden erfolgreich Abgeschlossen";
            this.color = "green";
            this.snackbar = true;
            this.Extern = [];
        }).catch((error) => {
            this.text = "Der eingescannte Auftrag wurden nicht erfolgreich Abgeschlossen";
            this.color = "red";
            this.snackbar = true;
        });
        this.snackbar = false;
        this.controll = "";
        this.controlldisabled = false;
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
};
OutsourceOutput = __decorate([
    Component({
        name: "OutsourceOutput",
    })
], OutsourceOutput);
export default OutsourceOutput;
